import React from "react";
import AddDocument from "./AddDocument";
import Document from "./Document";
import DocumentTitle from "./DocumentTitle";
import { useTranslation } from "react-i18next";
import { useCallback } from "react";
import { useEffect } from "react";
import * as Validator from "../requestPreviewDocumentsValidator";
import { subscribe, unsubscribe } from "../../../../../eventBus";

export const UPLOAD_STATUS = {
  NOT_STARTED: 0,
  IN_PROGRESS: 1,
  ERROR: 2,
  TIMEOUT: 3,
  SUCCESS: 4,
};

export const statusColor = (status) => {
  switch (status) {
    case UPLOAD_STATUS.ERROR:
    case UPLOAD_STATUS.TIMEOUT:
      return "red";
    case UPLOAD_STATUS.IN_PROGRESS:
      return "yellow";
    case UPLOAD_STATUS.SUCCESS:
      return "green";
    default:
      return "grey";
  }
};

function TextUpload({
  isAdditional,
  disabled,
  dispatchUpdateAction,
  documents,
  minDocumentsAttached,
  acceptDocumentTypes,
  maxDocumentSizeInMb,
  className = "",
  uploadUrl = `${process.env.REACT_APP_GATEWAY_URL}/upload`,
}) {
  const { t } = useTranslation();

  const validate = useCallback(() => {
    return {
      valid: Validator.minDocumentsAttached(documents, minDocumentsAttached),
      message: t("requests.submission.upload.minDocumentsAttached"),
    };
  }, [minDocumentsAttached, documents, t]);

  useEffect(() => {
    const subscriber = subscribe("validate-document-upload", () => {
      return validate();
    });
    return () => unsubscribe(subscriber);
  }, [validate]);
  return (
    <div className={`${className}`}>
      {documents.map((doc, index) => (
        <Document
          isAdditional={isAdditional}
          key={`doc${index}`}
          index={index}
          uploadStatus={doc.uploadStatus}
          renderDocumentTitle={() => (
            <DocumentTitle
              disabled={disabled}
              isAdditional={isAdditional}
              index={index}
              required={doc.required}
              label={doc.label}
              link={doc.link}
              dispatchUpdateAction={dispatchUpdateAction}
              documents={documents}
            />
          )}
        />
      ))}

      {!disabled && (
        <AddDocument
          documents={documents}
          dispatchUpdateAction={dispatchUpdateAction}
          color={isAdditional ? "red" : "grey"}
        />
      )}
    </div>
  );
}

export default TextUpload;
